import { render, staticRenderFns } from "./MtrlEdit.vue?vue&type=template&id=58fe5571&scoped=true&"
import script from "./MtrlEdit.vue?vue&type=script&lang=js&"
export * from "./MtrlEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fe5571",
  null
  
)

export default component.exports